import { render } from "./VocCountDown.vue?vue&type=template&id=3f56006e&scoped=true"
import script from "./VocCountDown.vue?vue&type=script&lang=js"
export * from "./VocCountDown.vue?vue&type=script&lang=js"

import "./VocCountDown.vue?vue&type=style&index=0&id=3f56006e&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f56006e"]])

export default __exports__